import { ApiClientOptions } from "./domains/base";
import { OpeningsClient } from "./domains/openings";
import { AppointmentsClient } from "./domains/appointments";
import { VerificationsClient } from "./domains/verifications";
import { CustomersClient } from "./domains/customers";
import { MediaClient } from "./domains/media";
import { PhotosClient } from "./domains/photos";
import { ContactClient } from "./domains/contact";
import { SalonsClient } from "./domains/salons";
import { LocationsClient } from "./domains/locations";
import { ServicesClient } from "./domains/services";
import { UsersClient } from "./domains/users";
import { ServiceRequestsClient } from "./domains/service-requests";
import { TeamMembersClient } from "./domains/team-members";
import { FeedbackClient } from "./domains/feedback";
import { FindClient } from "./domains/find";

/**
 * The public booking surfaces' client: only the domains the web app and the
 * website templates call. `OpeningsApiClient` constructs every domain client,
 * which kept every contract schema reachable from the booking page bundle
 * (Oct 2026). With `sideEffects: false` on api-client and api-contract, the
 * domains and schemas not listed here drop out of client bundles that use
 * this instead. Add a domain here only when a public surface needs it.
 */
export class BookingApiClient {
  openings: OpeningsClient;
  appointments: AppointmentsClient;
  verifications: VerificationsClient;
  customers: CustomersClient;
  media: MediaClient;
  photos: PhotosClient;
  contact: ContactClient;
  salons: SalonsClient;
  locations: LocationsClient;
  services: ServicesClient;
  users: UsersClient;
  serviceRequests: ServiceRequestsClient;
  teamMembers: TeamMembersClient;
  feedback: FeedbackClient;
  find: FindClient;
  constructor(opts: ApiClientOptions) {
    this.openings = new OpeningsClient(opts);
    this.appointments = new AppointmentsClient(opts);
    this.verifications = new VerificationsClient(opts);
    this.customers = new CustomersClient(opts);
    this.media = new MediaClient(opts);
    this.photos = new PhotosClient(opts);
    this.contact = new ContactClient(opts);
    this.salons = new SalonsClient(opts);
    this.locations = new LocationsClient(opts);
    this.services = new ServicesClient(opts);
    this.users = new UsersClient(opts);
    this.serviceRequests = new ServiceRequestsClient(opts);
    this.teamMembers = new TeamMembersClient(opts);
    this.feedback = new FeedbackClient(opts);
    this.find = new FindClient(opts);
  }
}

export function createBookingApiClient(
  baseUrl: string,
  opts?: Omit<ApiClientOptions, "baseUrl">,
) {
  return new BookingApiClient({ baseUrl, ...opts });
}
